import { io } from 'socket.io-client';
import store from '../store';
import { updateBookingStatus, addNotification } from '../store/bookingSlice';
import { addNewLead, removeLead } from '../store/partnerSlice';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

class SocketService {
  constructor() {
    this.socket = null;
    this.connected = false;
  }

  connect(userId, role) {
    if (this.socket && this.connected) {
      console.log('Socket already connected');
      return;
    }

    this.socket = io(SOCKET_URL, {
      auth: {
        userId,
        role,
      },
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    this.socket.on('connect', () => {
      console.log('Socket connected:', this.socket.id);
      this.connected = true;
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
      this.connected = false;
    });

    // Listen for booking status updates (for users)
    this.socket.on('booking:status_update', (data) => {
      console.log('Booking status update:', data);
      
      store.dispatch(
        updateBookingStatus({
          status: data.status,
          partner: data.partner,
        })
      );

      // Add notification
      store.dispatch(
        addNotification({
          id: Date.now(),
          type: 'booking_update',
          title: 'Booking Update',
          message: this.getStatusMessage(data.status),
          timestamp: new Date().toISOString(),
          read: false,
        })
      );
    });

    // Listen for partner acceptance (for users)
    this.socket.on('booking:partner_accepted', (data) => {
      console.log('Partner accepted booking:', data);
      
      store.dispatch(
        updateBookingStatus({
          status: 'accepted_by_partner',
          partner: data.partner,
        })
      );

      store.dispatch(
        addNotification({
          id: Date.now(),
          type: 'partner_accepted',
          title: 'Booking Confirmed! 🎉',
          message: `${data.partner.name} has accepted your booking request.`,
          timestamp: new Date().toISOString(),
          read: false,
        })
      );
    });

    // Listen for new leads (for partners)
    this.socket.on('lead:new', (data) => {
      console.log('New lead received:', data);
      
      store.dispatch(addNewLead(data.lead));

      store.dispatch(
        addNotification({
          id: Date.now(),
          type: 'new_lead',
          title: 'New Booking Request',
          message: `${data.lead.user.name} wants to book Cleansing Therapy (${data.lead.distance} km away)`,
          timestamp: new Date().toISOString(),
          read: false,
        })
      );
    });

    // Listen for lead cancellation (for partners)
    this.socket.on('lead:cancelled', (data) => {
      console.log('Lead cancelled:', data);
      store.dispatch(removeLead(data.leadId));
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }
  }

  // Emit events
  joinRoom(roomId) {
    if (this.socket && this.connected) {
      this.socket.emit('join:room', { roomId });
    }
  }

  leaveRoom(roomId) {
    if (this.socket && this.connected) {
      this.socket.emit('leave:room', { roomId });
    }
  }

  // Helper to get user-friendly status messages
  getStatusMessage(status) {
    const messages = {
      pending_partner_acceptance: 'Waiting for partner to accept...',
      accepted_by_partner: 'Your booking has been confirmed!',
      rejected_by_partner: 'Partner declined. Finding another partner...',
      cancelled_by_user: 'Booking cancelled',
      completed: 'Session completed successfully',
    };
    return messages[status] || 'Status updated';
  }
}

const socketService = new SocketService();
export default socketService;
